import { RequestStatus, SortOrder } from 'typed/api';
import { Action, ActionType } from 'typed/actions';
import { IReducer, networkActionReducer } from './';
import { Entity, IEntityReducerState, NetworkArray, NetworkPaginationSlice, isNetworkArray, isPaginationSlice, isSimpleArray } from './entityReducers';
import { deepAssign, deepClone } from 'typed/utils';

export default function entityLoadManyReducer<E extends Entity, S extends NetworkPaginationSlice<E>, T extends ActionType>(def: S, type: T): IReducer<S, Action<T>>;
export default function entityLoadManyReducer<E extends Entity, S extends NetworkArray<E>, T extends ActionType>(def: S, type: T): IReducer<S, Action<T>>;
export default function entityLoadManyReducer<E extends Entity, S extends E[], T extends ActionType>(def: S, type: T): IReducer<S, Action<T>>;
export default function entityLoadManyReducer<E extends Entity, T extends ActionType>(def: IEntityReducerState<E>, type: T): IReducer<any, Action<T>> {
    const nr = networkActionReducer<T, any>(type);
    return function entityLoadManyReducer(state: IEntityReducerState<E> | undefined = deepClone(def), action: Action<T>): IEntityReducerState<E> {
        if (action.type === type) {
            let newData = (isNetworkArray(state) ? state.Data : isSimpleArray(state) ? state : [state]).copy();

            for (let entityIndex = 0; entityIndex < action.payload.entityIDs.length; entityIndex++) {
                const
                    entityID = action.payload.entityIDs[entityIndex],
                    entity = action.payload.status === RequestStatus.SUCCEEDED ? action.payload.response.getByID(entityID) : newData.getByID(entityID);

                if (entity) {
                    const index = newData.getIndexByID(entityID);

                    if (index < 0 && action.payload.status === RequestStatus.SUCCEEDED) {
                        if (isPaginationSlice(state) && action.payload.startID && action.payload.response.Order !== SortOrder.DESCENDING) {
                            newData.splice(entityIndex, 0, nr(entity, action));
                        }
                        else {
                            newData.push(nr(entity, action));
                        }
                    }
                    else {
                        newData = deepAssign(newData, { [index]: nr(entity, action) });
                    }
                }

            }

            return isPaginationSlice(state) && action.payload.status === RequestStatus.SUCCEEDED ?
                nr(deepAssign(state, {
                    ...action.payload.response,
                    Data: newData,
                    Count: newData.length,
                    Custom: state.Custom
                }), action) :
                isNetworkArray(state) ?
                    nr(deepAssign(state, { Data: newData }), action) :
                    isSimpleArray(state) ?
                        newData :
                        newData[0];
        }

        return state;
    };
}
